import { useDealerFlagTarget } from "@hooks/useDealerFlagTarget";
import { useFeatureFlags } from "@lyteflo/components";
import { buildFlagsmithTraitsForDealerConfig } from "@lyteflo/utils/featureFlagsCache";
import { useEffect, useRef } from "preact/hooks";

export const useDealerFlagTraits = () => {
  const { updateFlagSmithTraitsWithDealerConfig } = useFeatureFlags();
  const { config, isSettled } = useDealerFlagTarget();
  const hasTargeted = useRef(false);
  const target = isSettled ? config : null;
  // Keyed on every trait that gets pushed, not just the id: segments can target
  // config_oem, config_status or config_group_id, and a revalidation can change
  // those while the dealership stays the same.
  const traitsKey = JSON.stringify(buildFlagsmithTraitsForDealerConfig(target));

  useEffect(() => {
    // Nothing targeted yet and nothing to target: the flag set already held
    // is the right answer, and pushing would spend a round trip to say so.
    if (!hasTargeted.current && target === null) return;
    hasTargeted.current = true;
    void updateFlagSmithTraitsWithDealerConfig(target);
  }, [traitsKey]);
};
